import React from "react";
import "./Reports.less";
import { apiBatchRequest, apiPost } from "../../utils/api_service";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  Tooltip,
  IconButton,
  Button,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  TableHead,
  Table,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions
} from "@material-ui/core";
import { ReportPageFilter } from "../common/FilterReport/ReportPageFilter";
import TableWithPaginations from "./TableWithPaginations";
import { API_URL } from "../../constants/api";
import {
  getDynamicFilter,
  getQueryParam,
  getToolTipText,
  GetUserConfiguration,
  IsSectionVisible,
  orderBy,
  ssrsReportDownload
} from "../../utils/helper";
import {
  getFormattedHeaders,
  getFormattedValues
} from "../../utils/formatData";
import { Report_List } from "../../constants/ssrs_api";
import { SECTIONS } from "../../constants/appConstants";
import DownloadSSRSPopUp from "../common/button-download-popup";
import { ShowToast, toastType } from "../../utils/toast-service";
import moment from "moment";
import FilterOff from "../../../src/public/img/common/filterOff.svg";
import commonLabels from "../../constants/messageConstants";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { getDiffInMonths } from "../../utils/date";

class ReportDataTable extends React.Component {
  constructor(props) {
    super(props);
    const {
      reportName,
      fileName,
      dateTypeSelected,
      filterName,
      filterConfig,
      reportSectionId,
      reportId,
      colFilteredObj,
      initialConfigData,
      isTooltipShow,
      toolTipData
    } = this.props;

    this.state = {
      reportName: reportName,
      fileName: fileName,
      dateTypeSelected: dateTypeSelected,
      filterName: filterName,
      filterConfig: filterConfig,
      reportSectionId: reportSectionId,
      reportId: reportId,
      reportData: [],
      showReport: false,
      order: "desc",
      orderByColumn: "",
      rows: [],
      colFilteredObj: colFilteredObj || [],
      initialConfigData: initialConfigData || [],
      enableDownload: false,
      clearFilterData: false,
      reload: false,
      isTooltipShow: isTooltipShow,
      toolTipData: toolTipData,
      reportFormat: "Excel",
      pageNo: 0,
    };
    this.baseState = this.state;
  }

  componentDidMount() {
    localStorage.setItem("isApiCalled","false");
    window.scrollTo(0, 0);
    this.getReportData();
  }

  /**
   * Get Report data according to selection of section and selected filters
   */
  getReportData = () => {
    const {
      reportId,
      reportSectionId,
      colFilteredObj,
      filterConfig,
      initialConfigData,
      isInErrorState,
      errorMessage
    } = this.state;
    const reportParam = getDynamicFilter(
      colFilteredObj,
      filterConfig,
      initialConfigData
    );
    if(!isInErrorState){
    if(localStorage.getItem("isApiCalled")!="true"){
    const dateIncluded = this.IsValidForViewOrDownload(
      filterConfig,
      colFilteredObj
    );
   
      if (!dateIncluded) {
        localStorage.setItem("isApiCalled","true");
        apiBatchRequest([
          {
            url: API_URL.reporting.getReportData,
            params: {
              reportId: reportId,
              sectionId: reportSectionId,
              dateOffset: moment().utcOffset(),
              reportParam:
                reportParam.length > 0 ? JSON.stringify(reportParam) : null
            },
            key: "reportData"
          }
        ]).then(({ reportData }) => {
          localStorage.setItem("isApiCalled","false");
          if (reportData.success !== true) {
            ShowToast(
              reportData.message,
              toastType.ERROR,
              5000,
              500,
              "Server error"
            );
            this.setState({
              reportData: [],
              configuration: [],
              showReport: false,
              rows: [],
              pageNo: 0,
               
            });
          } else {
            const { orderByColumn, order } = this.state;
            this.setState({
              reportData: reportData.rawData || [],
              configuration: reportData.data,
              showReport: true,
              rows: this.renderTableRow(
                orderBy(reportData.rawData || [], orderByColumn, order),              
                orderBy(reportData.data || [], "SortOrder", "ASE")
              ),
              pageNo: 0              
            });
          }
        });
      }
   
    
  }}
  else{
    ShowToast(errorMessage,toastType.ERROR,2000,500);
  }
  };

  /**
   * call on sorting of each row
   * @param {*} property -> selected row key name
   * @returns
   */
  handleRequestSort = property => {
    const { order, orderByColumn, reportData, configuration } = this.state;
    const isAsc = orderByColumn === property && order === "asc";

    let rows = [];
    rows = [
      ...rows,
      ...this.renderTableRow(
        orderBy(reportData || [], property, isAsc ? "desc" : "asc"),
        orderBy(configuration || [], "SortOrder", "ASE")
      )
    ];
    this.setState({
      order: isAsc ? "desc" : "asc",
      orderByColumn: property,
      rows
    });
  };

  /**
   * render rows according to data
   * @param {*} rows -> no. of rows with data
   * @returns
   */

  renderTable = rows => {
    const { order, orderByColumn, configuration } = this.state;
    return (
      <Table className={"reportTable"} id={"rptTable"}>
        <TableHead className={"background-table-header"}>
          <TableRow>
            {orderBy(configuration || [], "SortOrder", "ASE")
              ?.filter(x => x.IsVisible === true || x.IsVisible === 1)
              .map(config => (
                <TableCell
                  key={config.ColumnName}
                  sortDirection={
                    orderByColumn === config.ColumnDataType ? order : false
                  }
                  width={config.ColumnLength + "px"}
                >
                  <TableSortLabel
                    key={"TableSortLabel" + config.ColumnName}
                    active={orderByColumn === config.ColumnName}
                    direction={
                      orderByColumn === config.ColumnName ? order : "asc"
                    }
                    onClick={() => {
                      this.handleRequestSort(
                        config.ColumnName,
                        config.ColumnDataType
                      );
                    }}
                  >
                    {config.ColumnDataType !== undefined
                      ? getFormattedHeaders(
                          config.ColumnDisplayName,
                          config.ColumnDataType
                        )
                      : config.ColumnDisplayName}
                  </TableSortLabel>
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  /**
   * render rows according to data
   * @param {*} data -> data of report
   * @param {*} columns -> columns of report
   * @returns
   */
  renderTableRow = (data, columns) => {
    return this.renderTableCell(data, columns, []);
  };

  /**
   * render rows according to data
   * @param {*} groupedData -> data of report
   * @param {*} columns -> columns of report
   * @param {*} tableCell -> number of table cells
   * @param {*} rowCount -> row count
   * @returns
   */
  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0) => {
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? " rpt rpt-even " : " rpt rpt-odd ";
      const key = i + rowCount + "_" + i;
      tableCell.push(
        <TableRow key={key} className={"rpt-topBorder"}>
          {columns.map((col, index) => {
            return (
              <>
                {col.IsVisible === 1 || col.IsVisible === true ? (
                  <TableCell
                    key={d[col.ColumnName] + index + key}
                    className={evenOddClass + "rpt-topBorder"}
                    width={col.ColumnLength + "px"}
                  >
                    <>
                      {getFormattedValues(
                        d[col.ColumnName],
                        col.ColumnDataType
                      )}
                    </>
                  </TableCell>
                ) : (
                  ""
                )}
              </>
            );
          })}
        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(
        <TableRow>
          {" "}
          <TableCell colSpan={columns?.length} align={"center"}>
            {"No records found\r"}
          </TableCell>{" "}
        </TableRow>
      );
    }
    return tableCell;
  };

  /**
   * get the selected filters data
   * @param {*} selectedFilter -> selected filters
   * @returns
   */

  getSelectedFilter = (selectedFilter,filterConfig,inErrorState) => {
     const {isInErrorState}= this.state;
    this.setState(
      {
        filterConfig:filterConfig,
        colFilteredObj: selectedFilter,
        isInErrorState: inErrorState!==undefined? inErrorState: isInErrorState
      },
      () => {
        this.getReportData();
      }
    );
  };

  /**
   * run the report click on generate report and create query param string to pass the ssrs report
   * @returns
   */
  runReport = () => {
    const { enableDownload } = this.state;
    this.setState({
      enableDownload: !enableDownload
    });
    const {
      colFilteredObj,
      filterConfig,
      dateTypeSelected,
      initialConfigData
    } = this.state;

    let dateIncluded = false;
    filterConfig.forEach(n => {
      if (
        (n["FilterDataType"] == "DateRange" &&
        n["ReportId"] == 1 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeWeeklySlider" &&
        n["ReportId"] == 7 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeSlider" &&
        n["ReportId"] == 2 &&
        dateIncluded == false)
      ) {
        const dates = colFilteredObj
          ?.find(x => x.keyName == n["FilterKeyName"])
          ?.value?.split("-");
        const months = dates && getDiffInMonths(dates[0], dates[1]) + 1;
        if (months > 3) {
          this.openDialogToSendReport(
            colFilteredObj?.find(x => x.keyName == n["FilterKeyName"])?.value
          );
          dateIncluded = true;
        }
      }
    });
    const { reportId } = this.props;
    this.setState({
      reportData: [],
      queryParam: getQueryParam(
        colFilteredObj,
        filterConfig,
        dateTypeSelected,
        reportId,
        initialConfigData
      )
    });
  };

  /**
   * call in case of WorkOrder report and detail message
   * @param {*} value
   */
  openDialogToSendReport = value => {
    const dates = value?.split("-");
    const months = dates && getDiffInMonths(dates[0], dates[1]) + 1;
    const { enableDownload } = this.state;
    if (months > 12) {
      this.setState({
        enableDownload: !enableDownload
      });
      ShowToast(
        commonLabels.reportingDateExceed.message,
        toastType.ERROR,
        5000,
        200
      );
    } else if (months > 3) {
      const {
        colFilteredObj,
        filterConfig,
        dateTypeSelected,
        initialConfigData
      } = this.state;
      const { reportId } = this.props;

      this.setState({
        openDialog: true,
        TimePeriod: value,
        queryParam: getQueryParam(
          colFilteredObj,
          filterConfig,
          dateTypeSelected,
          reportId,
          initialConfigData
        )
      });
    }
  };

  /**
   * download the ssrs report
   * @param {*} report -> report ssrs url
   * @param {*} type -> report type to download
   * @returns
   */
  downloadSSRSReport = (report, type = "excel") => {
    const {
      fileName,
      reportName,
      colFilteredObj,
      filterConfig,
      dateTypeSelected,
      initialConfigData
    } = this.state;
    const { reportId, eventInitiatedFrom } = this.props;

    let queryParam = getQueryParam(
      colFilteredObj,
      filterConfig,
      dateTypeSelected,
      reportId,
      initialConfigData
    );
    queryParam = queryParam + `&EventInitiatedFrom=${eventInitiatedFrom}&ClickEvent=Download`;
    const dateIncluded = this.IsValidForViewOrDownload(
      filterConfig,
      colFilteredObj
    );
    if (!dateIncluded) {
      ssrsReportDownload(report, type, queryParam, fileName, reportName);
    }
  };

  /**
   * clear the filter list
   */
  clearFilter = () => {
    let { colFilteredObj } = this.state;

    colFilteredObj = colFilteredObj || [];
    const dateRangeFilter= colFilteredObj.filter(x=>x.filterType==="DateRangeSlider" || x.filterType === "DateRange") ||[];
    const weeklySlider = 
      colFilteredObj.filter(
        x => x.filterType === "DateRangeWeeklySlider") || [];
    const clearFilters = [];
    let dateTypeSelected = "NONE";
    if (dateRangeFilter.length > 0) {
      const start = moment()
        .startOf("month")
        .format("MM/DD/YYYY");
      const end = moment()
        .endOf("month")
        .format("MM/DD/YYYY");
      dateRangeFilter[0].value = start + "-" + end;
      clearFilters.push(dateRangeFilter[0]);
      dateTypeSelected = "MTD";
    } else if (weeklySlider.length > 0) {
      const start = moment()
        .format("MM/DD/YYYY");
      const end = moment()
        .format("MM/DD/YYYY");
        weeklySlider[0].value = start + "-" + end;
      clearFilters.push(weeklySlider[0]);
      dateTypeSelected = "TD";
    }
    localStorage.setItem("DateRadioSelect", dateTypeSelected);
    const { reload, clearFilterData, initialConfigData } = this.state;
    this.setState(
      {
        reload: !reload,
        clearFilterData: !clearFilterData,
        colFilteredObj: clearFilters,
        dateTypeSelected,
        filterConfig: JSON.parse(JSON.stringify([...initialConfigData])),
        isInErrorState:false
      },
      () => {
        this.getReportData();
      }
    );
  };

  /**
   * download the report according to selection
   * @param {*} value
   */
  handleDownloadReport = value => {
    const { orderByColumn, order, reload, configuration } = this.state;

    if (value == false) {
      this.setState({
        openDialog: false,
        reportFormat: "Excel",
        reportData: [],
        reload: !reload,
        rows: this.renderTableRow(
          orderBy([], orderByColumn, order),
          orderBy(configuration || [], "SortOrder", "ASE")
        )
      });
    } else {
      const { queryParam, fileName, reportName, reportFormat } = this.state;

      let reportUrl = null;
      switch (reportFormat) {
        case "MHTML":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}MHTML${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "WORD":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}WORD${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "PDF":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}PDF${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "Excel":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}EXCELOPENXML${queryParam.replace("&AccessGroupId=1", "")}`;
      }

      const userData = GetUserConfiguration();
      const accessGroupId = userData?.groups[0]?.accessGroupId || 0;
      const radioSelected = localStorage.getItem("DateRadioSelect");
      const { filterName } = this.props;
      const { TimePeriod } = this.state;
      const params = {
        url: `${reportUrl}&CloudOrgId=2&EmailID=${userData.email}&AccessGroupId=${accessGroupId}`,
        reportName: filterName,
        outFormat: reportFormat === "Excel" ? "xlsx" : reportFormat,
        downLoadFileName: fileName,
        selectedDateType:
          radioSelected == "MTD" || radioSelected == "Month"
            ? "Monthly - " + moment(TimePeriod).format("MMM/YYYY")
            : radioSelected == "YTD"
            ? "YTD - " + TimePeriod.replace("-", " thru ")
            : radioSelected == "YEAR"
            ? "Yearly - " + TimePeriod.replace("-", " thru ")
            : radioSelected == "QTR"
            ? "Quarter - " + TimePeriod.replace("-", " thru ")
            : radioSelected == "CDR"
            ? "Date Range - " + TimePeriod.replace("-", " thru ")
            : ""
      };
      apiPost({
        url: API_URL.reporting.generateReport,
        postBody: params
      }).then(({ success: success }) => {
        if (success) {
          ShowToast(
            "Request to generate report added Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
        } else {
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      });
      const { orderByColumn, order, reload, configuration } = this.state;

      this.setState({
        openDialog: false,
        reportFormat: "Excel",
        reportData: [],
        reload: !reload,
        rows: this.renderTableRow(
          orderBy([], orderByColumn, order),
          orderBy(configuration || [], "SortOrder", "ASE")
        )
      });
    }
  };

  /** Download validation check */
  IsValidForViewOrDownload(filterConfig, colFilteredObj) {
    let dateIncluded = false;
    filterConfig.forEach(n => {
      if (
       ( n["FilterDataType"] == "DateRange" &&
        n["ReportId"] == 1 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeWeeklySlider" &&
        n["ReportId"] == 7 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeSlider" &&
        n["ReportId"] == 2 &&
        dateIncluded == false)
      ) {
        const dates = colFilteredObj
          ?.find(x => x.keyName == n["FilterKeyName"])
          ?.value?.split("-");
        const months = dates && getDiffInMonths(dates[0], dates[1]) + 1;
        if (months > 3) {
          this.openDialogToSendReport(
            colFilteredObj?.find(x => x.keyName == n["FilterKeyName"])?.value
          );
          dateIncluded = true;
          this.setState({
            reportData: []
          });
        }
      }
    });
    return dateIncluded;
  }

  /**
   * render tooltip according to defined key
   * @returns
   */
  renderToolTip = () => {
    const { userData } = this.props;
    const { toolTipData, TimePeriod } = this.state;
    const resultArray = [];
    const toolTip = getToolTipText(toolTipData, "Generate Report");
    const toolTipParts = toolTip.split("@EmailId");
    resultArray.push(toolTipParts[0]);
    resultArray.push(<b>{userData}</b>);
    const toolTipParts1 = toolTipParts[1].split("@Date");
    resultArray.push(toolTipParts1[0]);
    resultArray.push(<b>{TimePeriod}</b>);
    resultArray.push(toolTipParts1[1]);
    return resultArray;
  };

  updatePageCount = (pageNo) => {
    this.setState({
      pageNo: pageNo
    })
  }

  onError = (value,message) => {
    // let colFiltered = this.state.colFilteredObj?.filter(e => {
    //   if (e.keyName !== key) return e;
    // });
    this.setState({
       isInErrorState: value,
       errorMessage:message
     });
  };

  render() {
    const {
      reportName,
      filterConfig,
      rows,
      order,
      orderByColumn,
      reportData,
      showReport,
      colFilteredObj,
      initialConfigData,
      clearFilterData,
      reload,
      isTooltipShow,
      toolTipData,
      filterName,
      openDialog,
      reportFormat,
      pageNo,
      reportSectionId
    } = this.state;
    const { loadUi } = this.props;
    return (
      <>
        <div className={"report-view-wrapper"}>
          <div className={"row pageHeader-container start-xs "}>
            <div className={"col-xs-auto pageHeader"}>{reportName}</div>
            <div
              className={"col-xs pageHeader pull-right end-xs"}
              key={"container-action-"}
            >
              <Tooltip
                title={
                  isTooltipShow
                    ? toolTipData?.find(
                        b => b.UiColumnName == "Back to Main Filter"
                      )?.Tooltip
                    : "Back to Report"
                }
              >
                <IconButton
                  key={"container-action-IC-"}
                  aria-label={"newWidget"}
                  size={"small"}
                  onClick={() => {
                    loadUi(false);
                  }}
                >
                  <ArrowBackIcon
                    size={"small"}
                    className={"back-button no-print"}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <div className={"report-page-filter bottom-xs"}>
            <div className={"col-xs-12"}>
            <ReportPageFilter
              filterConfig={filterConfig}
              colFilteredObj={colFilteredObj}
              selectedFilter={this.getSelectedFilter}
              initialConfigData={initialConfigData}
              clearFilterData={clearFilterData}
              reload={reload}
              reportSectionId={reportSectionId}
              onError={this.onError}
            />
            </div>
          </div>
          <div className={"col-xs-12 col-lg-12 filter-action-group"}>
            <div className={"row start-xs end-xs report-button-padding"}>
              <div style={{ marginTop: "-5px" }}>
                <Tooltip
                  title={
                    isTooltipShow
                      ? toolTipData?.find(b => b.UiColumnName == "Clear Filter")
                          ?.Tooltip
                      : "Clear Filter"
                  }
                  placement={"bottom"}
                >
                  <img
                    className={"icons"}
                    src={FilterOff}
                    alt={"logo"}
                    onClick={() => {
                      this.clearFilter();
                    }}
                  />
                </Tooltip>
              </div>
              &nbsp;&nbsp;&nbsp;
              {IsSectionVisible(
                SECTIONS.REPORTING,
                SECTIONS.REPORTING,
                SECTIONS.ADD_EDIT
              ) && (
                <DownloadSSRSPopUp
                  buttonLabel={"Print"}
                  dataTip={
                    isTooltipShow
                      ? toolTipData?.find(b => b.UiColumnName == "Download")
                          ?.Tooltip
                      : "Download"
                  }
                  reportList={[
                    {
                      label: filterName,
                      id: 1,
                      pdfDownload: true,
                      excelDownload: true,
                      downloadLink: Report_List
                    }
                  ]}
                  downloadBtnLabel={"Download"}
                  downloadReport={this.downloadSSRSReport}
                  isInErrorState={this.state.isInErrorState}
                  errorMessage={this.state.errorMessage}
                />
              )}
            </div>
          </div>
          {showReport && reportData !== null && (
            <div className={"table-container"} style={{ marginTop: "1rem" }}>
              <TableWithPaginations
                tableData={rows}
                paginationData={reportData}
                renderTable={this.renderTable}
                order={order}
                oBy={orderByColumn}
                pageNo={pageNo}
                updatePageCount={this.updatePageCount}
              />
            </div>
          )}

          {openDialog && (
            <Dialog
              style={{ marginTop: "60px" }}
              open={openDialog}
              aria-labelledby={"responsive-dialog-title"}
              maxWidth={"md"}
            >
              <AppBar
                style={{ position: "relative", backgroundColor: "#064473" }}
              >
                <Toolbar>
                  <Typography
                    variant={"h6"}
                    style={{ marginLeft: "10px", flex: "1" }}
                  >
                    {"Generate Report\r"}
                  </Typography>
                  <IconButton
                    title={"Close"}
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => this.handleDownloadReport(false, "")}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <div
                style={{
                  padding: "6px 13px",
                  fontSize: "larger",
                  lineHeight: "1.5rem"
                }}
              >
                {this.renderToolTip().map(el => {
                  return <>{el}</>;
                })}
              </div>

              <FormControl component={"fieldset"} className={"radio-btn-grp"}>
                <RadioGroup
                  aria-label={"Report Type"}
                  name={"reportFormat"}
                  className={"radioGroup"}
                  style={{
                    display: "inline-block",
                    marginLeft: "30px"
                  }}
                  value={reportFormat}
                  onChange={event =>
                    this.setState({ reportFormat: event.target.value })}
                >
                  <FormControlLabel
                    value={"Excel"}
                    control={
                      <Radio className={"radio-btn"} color={"primary"} />
                    }
                    label={"Excel"}
                  />
                  <FormControlLabel
                    value={"PDF"}
                    control={
                      <Radio className={"radio-btn"} color={"primary"} />
                    }
                    label={"PDF"}
                  />
                </RadioGroup>
              </FormControl>
              <DialogActions>
                <Button
                  className={"runReport-btn"}
                  variant={"contained"}
                  onClick={() => this.handleDownloadReport(false, "")}
                >
                  {"Close\r"}
                </Button>
                <Button
                  className={"runReport-btn"}
                  variant={"contained"}
                  onClick={() => this.handleDownloadReport(true, "")}
                >
                  {"Generate Report\r"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
      </>
    );
  }
}

export default ReportDataTable;
